/**
 * User
 */
export const SAVE_USER = 'SAVE_USER'

/**
 * Feature Flags
 */
export const STORE_FEATURE_FLAGS = 'STORE_FEATURE_FLAGS'

/**
 * Calendar Events
 */
export const CALENDAR_EVENTS_FETCH_START = 'CALENDAR_EVENTS_FETCH_START'
export const CALENDAR_EVENTS_FETCH_FAIL = 'CALENDAR_EVENTS_FETCH_FAIL'
export const CALENDAR_EVENTS_FETCH_SUCCESS = 'CALENDAR_EVENTS_FETCH_SUCCESS'
